import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';

export default function PrivateRoutes() {
    const token = localStorage.getItem("accessToken");
    return token  ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />
}
